import React from "react";
import { Container, Col, Button, ButtonGroup } from "reactstrap";
import { isDesktopApp, isGamedistributionApp, canUseDOM } from "~/utils/misc";
import ModalComponent from "~/components/ModalComponent";
import { getCookie, saveCookie } from "~/utils/cookie";

export function onSettingTap(setting, value) {
  // Save setting
  saveCookie(setting, value);

  // Set Electron menu
  if (isDesktopApp() && is.existy(window.electron)) {
    // Set Electron menu
    window.electron.setElectronMenu({
      settings_show_time: {
        checked: is.truthy(getCookie("settingsShowTime", true)),
        enabled: true
      },
      settings_start_on_login: {
        checked: is.truthy(getCookie("macSettingsStartAtLogin", false)),
        enabled: true
      }
    });

    // Set start at login if needed
    if (is.equal(setting, "macSettingsStartAtLogin")) {
      window.electron.setStartAtLogin(value);
    }
  }

  // Emit event
  emitter.emit("settingsDidChange");

  // Re-render HTML
  this.forceUpdate();
}

export function settingsModalElement() {
  return (
    <ModalComponent
      className="settings_modal"
      onRef={ref => {
        this.settingsModal = ref;
      }}
    >
      <Container>
        <Col>
          <div className="setting_container start_on_login_container">
            <p>Start on login</p>
            <ButtonGroup>
              <Button
                color="light"
                onClick={() =>
                  this.onSettingTap("macSettingsStartAtLogin", false)
                }
                active={is.falsy(
                  getCookie("macSettingsStartAtLogin", false)
                )}
              >
                Off
              </Button>
              <Button
                color="light"
                onClick={() =>
                  this.onSettingTap("macSettingsStartAtLogin", true)
                }
                active={is.truthy(
                  getCookie("macSettingsStartAtLogin", false)
                )}
              >
                On
              </Button>
            </ButtonGroup>
          </div>
          <div className="setting_container">
            <p>Show time</p>
            <ButtonGroup>
              <Button
                color="light"
                onClick={() =>
                  this.onSettingTap("settingsShowTime", false)
                }
                active={is.falsy(getCookie("settingsShowTime", true))}
              >
                Off
              </Button>
              <Button
                color="light"
                onClick={() =>
                  this.onSettingTap("settingsShowTime", true)
                }
                active={is.truthy(getCookie("settingsShowTime", true))}
              >
                On
              </Button>
            </ButtonGroup>
          </div>
          <If condition={canUseDOM() && global.parser.getBrowser().name != "Safari"}>
            <div className="setting_container">
              <p>Sound</p>
              <ButtonGroup>
                <Button
                  color="light"
                  onClick={() =>
                    this.onSettingTap("settingsSound", false)
                  }
                  active={is.falsy(getCookie("settingsSound", true))}
                >
                  Off
                </Button>
                <Button
                  color="light"
                  onClick={() =>
                    this.onSettingTap("settingsSound", true)
                  }
                  active={is.truthy(getCookie("settingsSound", true))}
                >
                  On
                </Button>
              </ButtonGroup>
            </div>
          </If>
        </Col>
      </Container>
    </ModalComponent>
  );
}



// WEBPACK FOOTER //
// ./src/components/MenuComponent/helpers/settingsModalElement.js